import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { SharedService } from '../../services/sharedservices.service';
import * as CryptoJS from 'crypto-js';
import { config } from 'config/config';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private sharedservice: SharedService) { }

    canActivate() {
        if ((location.protocol !== 'https:')) {
            location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
            return false;
        }

        if (this.sharedservice.checkCredentials()) {
            // logged in so return true            
            let conversionOutput = CryptoJS.AES.decrypt(localStorage.getItem("mca_d"), config.key).toString(CryptoJS.enc.Utf8);
            //let convertedObj = JSON.parse(conversionOutput);
            //let conversionSessionOutput = CryptoJS.AES.decrypt(convertedObj["res"], config.key).toString(CryptoJS.enc.Utf8);

            this.sharedservice.session = JSON.parse(conversionOutput);
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    }
}


// WEBPACK FOOTER //
// /tmp/build_713add00/src/app/guard/guard.ts